var render = function render(){var _vm=this,_c=_vm._self._c;return _c('KLogo',{attrs:{"altText":"Kolibri logo - monoSecondary","size":120,"showBackground":true,"colorScheme":"monoSecondary"}})
}
var staticRenderFns = []

export { render, staticRenderFns }